import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { Select } from '@ngxs/store';
import { Observable } from 'rxjs';
import { UsersState } from 'src/shared/store/state/users.state';

import { EntityTypeEnum } from '../../../enums/entity-type.enum';
import { IQuestionChoices } from '../../../interfaces/radio-checkbox-config.interface';
import { IUser } from '../../../interfaces/users/user.interface';
import { AuthState } from '../../../store/state/auth.state';
import { EnumsState } from '../../../store/state/enums.state';

@Component({
    selector: 'app-settings',
    templateUrl: './settings.component.html',
    styleUrls: ['./settings.component.scss'],
})
export class SettingsComponent implements OnChanges {
    @Select(EnumsState.costsRepartition) public costsRepartitionChoices$: Observable<IQuestionChoices[]>;
    @Select(AuthState.connectedUserType) public connectedUserType$: Observable<EntityTypeEnum>;
    @Select(UsersState.userToEdit) public userToEdit$: Observable<IUser>;
    @Input() public control: FormGroup;
    @Input() public parents: IUser[];
    @Input() public userType: EntityTypeEnum;
    @Input() public errorCustodies: boolean;
    @Input() public readOnly = false;

    @Output() public elementSizeModification = new EventEmitter<void>();
    @Output() public openModalCalendar = new EventEmitter<void>();

    public userTypeEnum = EntityTypeEnum;

    ngOnChanges(simplesChanges: SimpleChanges): void {
        if (simplesChanges && simplesChanges.parents && simplesChanges.parents.currentValue) {
            this.parents = simplesChanges.parents.currentValue;
        }
    }

    public goCalendar(): void {
        this.openModalCalendar.emit();
    }

    /* USERS GETTERS */
    public get notification(): FormControl {
        return this.control.get('notification') as FormControl;
    }

    public get msgCopyByMail(): FormControl {
        return this.control.get('msg_copy_by_mail') as FormControl;
    }

    /* STUDENTS GETTERS */
    public get isParentDivorced(): FormControl {
        return this.control.get('parent_divorced') as FormControl;
    }

    public get isParentsAuthorized(): FormControl {
        return this.control.get('parents_authorized') as FormControl;
    }

    public get costsRepartition(): FormControl {
        return this.control.get('costs_repartition_id') as FormControl;
    }

    public get repartitionRatio1(): FormControl {
        return this.control.get('parent_one_attributes').get('repartition_ratio') as FormControl;
    }

    public get repartitionRatio2(): FormControl {
        return this.control.get('parent_two_attributes').get('repartition_ratio') as FormControl;
    }

    public get parent1Id(): FormControl {
        return this.control.get('parent_one_attributes').get('parent_id') as FormControl;
    }
}
